import $ from 'cash-dom'

const pauseVideos = (modal) => {
  const videos = modal.find('video')
  if (!videos.length) return

  videos.each((index, video) => {
    video.pause()
  })
}

$('modal-panel').on('click', (e) => {
  if ($(e.target).is('modal-overlay')) {
    pauseVideos($(e.currentTarget))
  }
})
$('[data-action="hide-modal"]').on('click', function hideVideoModal() {
  const modal = $(this).closest('modal-panel')
  pauseVideos(modal)
})

$('[data-element="audio-toggle"]').on('click', function toggleVideoAudio() {
  const $videoElement = $(this).closest('[data-element="video"]')
  const video = $videoElement.find('video')[0]

  const swiperContainer = $videoElement.closest('swiper-container')
  const swiper = swiperContainer[0]?.swiper

  const $mutedIcon = $(this).find('.muted')
  const $unmutedIcon = $(this).find('.unmuted')

  video.muted = !video.muted

  if (video.muted) {
    $mutedIcon.removeClass('hidden')
    $unmutedIcon.addClass('hidden')

    if (swiper && swiper.autoplay) {
      swiper.autoplay.start()
    }
  } else {
    if (swiper && swiper.autoplay) {
      swiper.autoplay.stop()
    }

    $mutedIcon.addClass('hidden')
    $unmutedIcon.removeClass('hidden')
  }
})

const buildLazyLoad = () => {
  const lazyVideos = document.querySelectorAll('.lazy-video')

  if ('IntersectionObserver' in window) {
    const videoObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const video = entry.target
          const videoSrc = video.getAttribute('data-src')
          const isLoaded = video.getAttribute('src')
          if (isLoaded) return

          const source = video.querySelector('source')
          const sourceSrc = source.getAttribute('data-src')

          if (videoSrc && sourceSrc) {
            video.src = videoSrc
            source.src = sourceSrc
            video.load()
            videoObserver.unobserve(video)
          } else {
            console.error(
              'data-src attribute is missing for video or source',
              video
            )
          }
        }
      })
    })

    lazyVideos.forEach((video) => {
      videoObserver.observe(video)
    })
  } else {
    lazyVideos.forEach((video) => {
      const videoSrc = video.getAttribute('data-src')
      const isLoaded = video.getAttribute('src')
      const source = video.querySelector('source')
      const sourceSrc = source.getAttribute('data-src')

      if (isLoaded) return
      if (videoSrc && sourceSrc) {
        video.src = videoSrc
        source.src = sourceSrc
        video.load()
      } else {
        console.error(
          'data-src attribute is missing for video or source',
          video
        )
      }
    })
  }
}

document.addEventListener('DOMContentLoaded', () => {
  buildLazyLoad()
})

export { buildLazyLoad }
